import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const saveRequest: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { collectionApi },
) =>
  action$.pipe(
    ofType(actions.SAVE_REQUEST_ACTIONS.REQUESTED),
    switchMap(({ payload: { request, collections } }) => {
      return collectionApi.saveRequest(request, collections).pipe(
        switchMap(() =>
          of(
            actions.saveRequestSucceeded(),
            actions.storeRequested(store.value.storePage.storeId),
          ),
        ),
        catchError(error => of(actions.saveRequestFailed(error))),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Store/services/epics/saveRequest.ts